import styled from "styled-components";

export const InlineBannerContainer = styled.div`
  display: flex;
  background-color: #ececec;
  width: 100%;
  min-height: 120px;
  border-radius: 10px;
  align-items: center;
  gap: 16px;
  padding-right: 20px;
  box-sizing: border-box;

  @media (max-width: 627px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px;
  }
`;

export const ImageContent = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: 20px;

  @media (max-width: 627px) {
    gap: 12px;
  }
`;

export const ImageWrapper = styled.div`
  flex: 0 0 25%;
  align-self: stretch;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px 0 0 10px;
  overflow: hidden;
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: 120px;
  object-fit: contain;

  @media (max-width: 627px) {
    height: 90px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0;
  overflow-wrap: anywhere;

  &:first-child {
    padding-left: 20px;
  }

  @media (max-width: 627px) {
    padding: 0;

    &:first-child {
      padding-left: 0;
    }
  }
`;

export const Title = styled.span`
  color: #000000;
  font-weight: bold;
  font-size: 15px;
  ${({ theme }) => theme.fonts.primary};

  @media (max-width: 627px) {
    font-size: 13px;
  }
`;

export const Description = styled.span`
  color: #000000;
  font-weight: normal;
  font-size: 15px;
  ${({ theme }) => theme.fonts.primary};
  margin-top: 3px;

  @media (max-width: 627px) {
    font-size: 12px;
    line-height: 1.3;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  @media (max-width: 627px) {
    align-self: flex-end;
  }
`;
